import { FilterOption } from '@britishcouncil/react-admin';

export const createEnumOptions = <
  TEnum extends Record<string, string | number>,
  TValue extends number,
>(
  enumObject: TEnum,
  getLabel: (value: TValue) => string
): FilterOption<TValue>[] => {
  return Object.values(enumObject)
    .filter((value): value is TValue => typeof value === 'number')
    .map((value) => ({
      text: getLabel(value),
      value,
    }));
};
